import { contactItem } from '@/mocks/homeData';

export default function Contact() {
  return (
    <section id="contact" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">{contactItem.title}</h2>
          <p className="text-sm text-foreground-400 mb-2">{contactItem.subtitle}</p>
          <p className="text-sm text-foreground-500 leading-relaxed mb-8">{contactItem.description}</p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8">
            <div className="flex items-center gap-3 bg-background-100 rounded-lg px-5 py-3">
              <i className="ri-mail-line text-primary-500 text-xl"></i>
              <div className="text-left">
                <div className="text-xs text-foreground-400">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-800">{contactItem.email}</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-background-100 rounded-lg px-5 py-3">
              <i className="ri-wechat-line text-primary-500 text-xl"></i>
              <div className="text-left">
                <div className="text-xs text-foreground-400">微信公众号</div>
                <div className="text-sm font-medium text-foreground-800">{contactItem.wechat}</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-background-100 rounded-lg px-5 py-3">
              <i className="ri-qq-line text-primary-500 text-xl"></i>
              <div className="text-left">
                <div className="text-xs text-foreground-400">QQ 群</div>
                <div className="text-sm font-medium text-foreground-800">{contactItem.qq}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}